module.exports = __webpack_public_path__ + "static/media/almada.6f7bfa2b.jpg";